import { SpicePatch, StdPatch } from "..";
import { replace, bytesMatch, toHexString } from "../utils/binary";
import { createID } from "../utils/html";
import { Patcher } from ".";
import StandardPatchUI from "../../components/Patchs/StandardPatcherUI";
import { Signal, createSignal } from "solid-js";

export class StandardPatcher implements Patcher {
    name: string;
    tooltip: string | undefined;
    danger: string | undefined;

    patches: {
        offset: number;
        on: number[];
        off: number[];
    }[];

    enabled: Signal<boolean>;
    id: string;

    constructor(options: StdPatch, baseAddr: number) {
        this.name = options.name;
        this.patches = options.patches.map(v => ({
            on: v.on,
            off: v.off,
            offset: v.va !== undefined ? v.va - baseAddr : v.offset,
        }));
        this.tooltip = options.tooltip;
        this.danger = options.danger;
        this.enabled = createSignal(false);
        this.id = createID();
    }

    get uiOnly(): boolean {
        return false;
    }

    ui() {
        return StandardPatchUI(this);
    }

    applyPatch(file: Uint8Array) {
        const [enabled] = this.enabled;
        return this.replaceAll(file, enabled());
    }

    replaceAll(file: Uint8Array, featureOn?: boolean) {
        return this.patches.forEach(patch => {
            replace(file, patch.offset, featureOn ? patch.on : patch.off);
        });
    }

    checkPatchBytes(file: Uint8Array): boolean {
        const enabled = this.patches
            .filter(p => bytesMatch(file, p.offset, p.on));

        const disabled = this.patches
            .filter(p => bytesMatch(file, p.offset, p.off));

        if (enabled.length + disabled.length != this.patches.length) {
            throw new Error('patch mismatch');
        }

        if (enabled.length && !disabled.length) {
            return true;
        }

        if (disabled.length && !enabled.length) {
            return false;
        }

        throw new Error('patch neither on nor off');
    }

    validatePatch(file: Uint8Array): { valid: boolean, message?: string } {
        const [_, setEnabled] = this.enabled;

        try {
            setEnabled(this.checkPatchBytes(file));
        } catch {
            return { valid: false, message: '<b>' + this.name + '</b> 既不是开也不是关! 你是不是开错文件了?' };
        }

        return { valid: true };
    }

    exportPatch2X(gameCode: string, dateCode: number, dllName: string): SpicePatch | undefined {
        return {
            dateCode,
            description: this.tooltip || this.danger || '',
            gameCode,
            name: this.name,
            preset: true,
            type: 'memory',
            patches: this.patches.map(v => ({
                dataDisabled: toHexString(v.off),
                dataEnabled: toHexString(v.on),
                dataOffset: v.offset,
                dllName,
            })),
        };
    }

    exportPatch(gameCode: string, dateCode: number, dllName: string): SpicePatch | undefined {
        const [enabled] = this.enabled;

        if (!enabled())
            return undefined;

        return {
            dateCode,
            description: this.tooltip || this.danger || '',
            gameCode,
            name: this.name,
            preset: true,
            type: 'memory',
            patches: this.patches.map(v => ({
                dataDisabled: toHexString(v.off),
                dataEnabled: toHexString(v.on),
                dataOffset: v.offset,
                dllName,
            })),
        };
    }
}
